import News from './news'

News()